<div class="input-group">
	<input
		id="scanInput"
		inputAutofocus
		[placeholder]="inputPlaceholder"
		(keydown)="keyDown($event)"
		#txtBarcode
		type="text"
		class="form-control"
		autocomplete="off"
		[disabled]="isDisabled || isProcessing"
	/>
	@if (showHelp) {
        <div class="input-group-append">
            <fa-icon 
                [icon]="faIcon.faSquareQuestion" 
                class="icon-size help-icon" 
                (click)="helpButtonClicked()"
            ></fa-icon>
        </div>
    }
</div>

<!-- Help Button Clicked Modal -->
<ng-template 
	#helpModal 
	let-modal
>
	<div class="modal-header">
		<h5>Scanner Help</h5>
		<button 
			type="button" 
			class="close" 
			aria-label="Close" 
			(click)="modal.dismiss()"
		>
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	
	<div class="modal-body flex-body">
		<h5>
			<img src="/assets/images/informational/qr-code.png" alt="" />
		</h5>
		<p>
			Please locate the GS1 DataMatrix barcode that looks similar to this one. <br /><br />
			Standard barcodes will not work. <br /><br />
			Simply use your barcode scanner to scan this making sure you have first clicked into the input field to the
			left of the help button. <br /><br />
			<b>Tip: </b>If your barcode and QR matrix are close to each other cover up the barcode with your other hand.
            <br /> <br/>For more information, visit 
            <a 
                href="https://knowledge.schedule2.it/en/what-barcodes-should-i-be-scanning" 
                target="_blank"
            >our support page</a>
		</p>
	</div>
</ng-template>